import { BulkSpreadsheet, parseBool, parseNum, type BulkColumn } from '../shared/BulkSpreadsheet';
import { purchaseOrderService } from '@kss/api';
import type { PurchaseOrderCreate } from '@kss/api';
import { loadStoreOptions, loadSupplierOptions, loadWarehouseOptions } from '../shared/formLoaders';

/* `warehouseId` added 2026-05-21 — backend rejects PO inserts
   without it (`REQUIRED_FIELD:WarehouseId` from POST /api/PurchaseOrder). */
const columns: BulkColumn<PurchaseOrderCreate>[] = [
  { key: 'orderNumber', header: 'PO #', required: true, sample: 'PO-1001' },
  { key: 'orderDate', header: 'Order date', dataType: 'date', sample: new Date().toISOString().slice(0, 10) },
  { key: 'expectedDate', header: 'Expected date', dataType: 'date' },
  { key: 'supplierId', header: 'Supplier', dataType: 'lookup', loadOptions: loadSupplierOptions },
  { key: 'storeId', header: 'Store', dataType: 'lookup', loadOptions: loadStoreOptions },
  { key: 'warehouseId', header: 'Warehouse', dataType: 'lookup', loadOptions: loadWarehouseOptions, required: true },
  { key: 'totalAmount', header: 'Total', dataType: 'number', parse: parseNum as never, required: true, sample: '15000' },
  { key: 'status', header: 'Status', sample: 'Draft' },
  { key: 'notes', header: 'Notes' },
  { key: 'isActive', header: 'Active', dataType: 'boolean', parse: parseBool as never, sample: 'true' },
];

export default function BulkPurchaseOrder() {
  return (
    <BulkSpreadsheet<PurchaseOrderCreate> title="Bulk import purchase orders" entityLabel="PO" backPath="/panel/purchase-orders" columns={columns} module="PurchaseOrder"
      onImport={async (rows) => {
        const payload = rows.map((r) => ({ ...r, totalAmount: Number(r.totalAmount ?? 0), isActive: r.isActive ?? true }));
        const created = await purchaseOrderService.create(payload);
        return { created: Array.isArray(created) ? created.length : payload.length };
      }}
    />
  );
}
